import React from 'react';
import { __route } from 'localisation';
import Modal from 'components/Modal';
import Wrapper from '@hubins/components/Wrapper';
import Heading from 'components/Heading';
import HighlightedSentence from 'components/HighlightedSentence';
import Icon from '@hubins/components/IconNew';
import { Columns, Column } from 'components/Columns';
import { Link } from "react-router-dom";
import './index.scss';

const sources = [
  {
    title: 'Överskott lön',
    icon: 'Common File Text by Streamlinehq',
    type: 'salary'
  },
  {
    title: 'Försäljning av fastighet',
    icon: 'Common File Text by Streamlinehq',
    type: 'property'
  }
];

const SourceButton = ({ title, icon, premium, type, portfolioUuid }) => {
  return (
    <Link className='source_button' to={`${__route('sof')}/${portfolioUuid}/${type}${premium ? '/premium' : ''}`}>
      <div className='source_button__header'>
        <Heading size="4" className="flex-center--horizontal space-between">
          {title} <Icon icon={icon} size={16} color="primary" />
        </Heading>
      </div>
      <div>
        <HighlightedSentence>Ange som källa</HighlightedSentence>
      </div>
    </Link>
  );
};

const AddSourceModal = ({ open, premium, callback, portfolioUuid }) => {
  return (
    <Modal closeButton shouldCloseOnOverlayClick open={open} callback={callback}>
      <Wrapper>
        <Columns>
          {sources.map((source, index) => (
            <Column xs="12" s="6" m="6" l="4" key={`source_button-${index}`}>
              <SourceButton
                title={source.title}
                icon={source.icon}
                premium={premium}
                type={source.type}
                portfolioUuid={portfolioUuid}
              />
            </Column>
          ))}
        </Columns>
      </Wrapper>
    </Modal>
  );
};

export default AddSourceModal;
